import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';

import CardImage from '../../CardImage';
import CardContent from '../../CardContent';

// TODO: Write tests
export const generateCardContentClassNames = ({ contentBoxAlignment }) => (
  classNames('card__content', {
    'card__content--overlay-bottom-1of3': contentBoxAlignment === 'bottom',
    'card__content--overlay-top-1of3': contentBoxAlignment === 'top',
    [`align-${contentBoxAlignment}`]: contentBoxAlignment,
  })
);

// TODO: Write tests
export const generateCardContentBoxClassNames = ({ contentBoxAlignment, extraCardContentBoxClassNames }) => (
  classNames('card__content-box', {
    'card__content-box--overlay-bottom-1of3': contentBoxAlignment === 'bottom',
    'card__content-box--overlay-top-1of3': contentBoxAlignment === 'top',
    [`${extraCardContentBoxClassNames}`]: extraCardContentBoxClassNames,
  })
);

// TODO: Verify this component could be embedded in both 1/3 variants similarly to CardsStacked
// Note: this doesn't need CardElement because it's parent components already wrap it in one
const CardsOneThirdMarkup = ({
  contentBoxAlignment,
  title,
  description,
  link,
  imageSrc,
  imageSrcSet,
  alt,
  isTitleUnderlined,
  tagHeadingLevel,
  isTagUnderlined = false,
  showStarRating = false,
  headingLevel,
  extraCardContentBoxClassNames,
  cover,
  zoomOnHover,
  fixedHeight,
  hideDescription,
  openLinkInNewTab,
  fullClickableArea,
  renderCustomRating,
}) => (
  <Fragment>
    {contentBoxAlignment === 'bottom' && (
      <CardImage
        src={imageSrc}
        srcset={imageSrcSet}
        alt={alt}
        cover={cover}
        zoomOnHover={zoomOnHover}
        fixedHeight={fixedHeight}
      />
    )}

    {(title || description) && (
      <CardContent
        description={description}
        title={title}
        linkUrl={R.prop('url')(link)}
        linkText={R.prop('text')(link)}
        tagHeadingLevel={tagHeadingLevel}
        isTagUnderlined={isTagUnderlined}
        showStarRating={showStarRating}
        cardContentClassNames={generateCardContentClassNames({ contentBoxAlignment })}
        cardContentBoxClassNames={generateCardContentBoxClassNames({
          contentBoxAlignment,
          extraCardContentBoxClassNames,
        })}
        headingLevel={headingLevel}
        isTitleUnderlined={isTitleUnderlined}
        hideDescription={hideDescription}
        openLinkInNewTab={openLinkInNewTab}
        fullClickableArea={fullClickableArea}
        renderCustomRating={renderCustomRating}
      />
    )}

    {contentBoxAlignment === 'top' && (
      <CardImage
        src={imageSrc}
        srcset={imageSrcSet}
        alt={alt}
        cover={cover}
        zoomOnHover={zoomOnHover}
        fixedHeight={fixedHeight}
      />
    )}
  </Fragment>
);

CardsOneThirdMarkup.propTypes = {
  contentBoxAlignment: PropTypes.string,
  description: PropTypes.string,
  imageSrc: PropTypes.string,
  imageSrcSet: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  })),
  alt: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  }),
  isTitleUnderlined: PropTypes.bool,
  showStarRating: PropTypes.bool,
  headingLevel: PropTypes.number,
  tagHeadingLevel: PropTypes.number,
  isTagUnderlined: PropTypes.bool,
  extraCardContentBoxClassNames: PropTypes.string,
  cover: PropTypes.bool,
  zoomOnHover: PropTypes.bool,
  fixedHeight: PropTypes.bool,
  hideDescription: PropTypes.bool,
  openLinkInNewTab: PropTypes.bool,
  fullClickableArea: PropTypes.bool,
  renderCustomRating: PropTypes.func,
};

export default CardsOneThirdMarkup;
